// Domain types for the Admin Vendors MSPA.

// The CountryPicker (react-bootstrap-country-select) yields either a country id
// string or an object; we accept both and extract the id when building payloads.
export type CountryValue = string | { id?: string; name?: string } | null;

// A row in the vendors list table.
export interface Vendor {
  id: string;
  name: string;
  streetAddress?: string;
  street2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  projectCount?: number;
  active?: boolean;
}

// Controlled values for the vendor create/edit form.
export interface VendorFormValues {
  name: string;
  streetAddress: string;
  street2: string;
  city: string;
  state: string;
  postalCode: string;
  country: CountryValue;
}

export const emptyVendorForm: VendorFormValues = {
  name: "",
  streetAddress: "",
  street2: "",
  city: "",
  state: "",
  postalCode: "",
  country: "",
};

export type VendorEditTab = "vendor" | "special_conditions";
